export default function uniqueContactNameDirective(
  $q,
  vmDataService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const productId = attributes.productId || -1;
    const contactId = attributes.contactId || -1;
    ngModel.$asyncValidators.uniqueContactName = modelValue => vmDataService.checkContactExists(
      productId, contactId, modelValue
    )
      .then((data) => {
        if (data && !data.data.result) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'uniqueContactName';

uniqueContactNameDirective.$inject = [
  '$q',
  'vmDataService'
];
